var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBy = function SvgBy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c8bf5160-7081-4b14-a842-9b1a5a825817a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ccd61724-9daa-413b-8c39-b2d2e50bd1d3b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ccd61724-9daa-413b-8c39-b2d2e50bd1d3b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0091E",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m3 0 2 1.5L3 3zm0 3 2 1.5L3 6zm0 3 2 1.5L3 9zm0 3 2 1.5L3 12zm0 3 2 1.5L3 15zM2 0 0 1.5 2 3zm0 3L0 4.5 2 6zm0 3L0 7.5 2 9zm0 3-2 1.5L2 12zm0 3-2 1.5L2 15zM2 0h1v2H2zm0 13h1v2H2zm0-8h1v2H2zm0-2h1v1H2zm0 8h1v1H2zm0-3h1v2H2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46A753",
    fillRule: "evenodd",
    d: "M5 11h16v4H5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c8bf5160-7081-4b14-a842-9b1a5a825817a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgBy;